import React, { useContext, useRef, useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useRect } from '@reach/rect'
import { Tab } from '@reach/tabs'

import colors from '../../styles/colors'
import { AnimatedContext } from './Tabs'

function AnimatedTab(props) {
  const { isSelected } = props

  // Each tab measures itself
  const ref = useRef()
  const rect = useRect(ref, isSelected)

  // and calls up to the parent when it becomes selected
  // we useLayoutEffect to avoid flicker
  const setSelectedRect = useContext(AnimatedContext)
  useLayoutEffect(() => {
    if (isSelected) setSelectedRect(rect)
  }, [isSelected, rect, setSelectedRect])

  return <StyledTab tabindex="0" ref={ref} {...props} isSelected={isSelected} />
}

const StyledTab = styled(Tab)`
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 10px;
  color: ${(props) =>
    props.isSelected ? `${colors.black}` : `${colors.light_black}`};
`

export default AnimatedTab
